import styled from '@emotion/styled';
import { FormControl, InputGroup, Spinner } from 'react-bootstrap';
import { RED, WHITE, BLACK, LARGE_BUTTON_BOX_SHADOW_COLOR } from '../../styles/color';
import {
  MIRA_PAYMENT_LAYOUT_PC_TITLE_MARGIN_TOP,
  MIRA_PAYMENT_LAYOUT_PC_TITLE_MARGIN_BOTTOM,
  MIRA_PAYMENT_LAYOUT_TABLET_TITLE_MARGIN_TOP,
  MIRA_PAYMENT_LAYOUT_TABLET_TITLE_MARGIN_BOTTOM,
  MIRA_PAYMENT_LAYOUT_SMART_TITLE_MARGIN_TOP,
  MIRA_PAYMENT_LAYOUT_SMART_TITLE_MARGIN_BOTTOM,
  MIRA_PAYMENT_LAYOUT_PC_TITLE_FONT,
  MIRA_PAYMENT_LAYOUT_PC_TITLE_FONT_HEIGHT,
  MIRA_PAYMENT_LAYOUT_PC_TITLE_FONT_SPACING,
  MIRA_PAYMENT_LAYOUT_TABLET_SMART_TITLE_FONT,
  MIRA_PAYMENT_LAYOUT_TABLET_SMART_TITLE_FONT_HEIGHT,
  MIRA_PAYMENT_LAYOUT_TABLET_SMART_TITLE_FONT_SPACING,
  MIRA_PAYMENT_LAYOUT_PC_TABLET_WIDTH,
  MAIN_FULL_WIDTH,
  MIRA_PAYMENT_LAYOUT_PC_MARGIN_BOTTOM,
  MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_PC_FONT_SIZE,
  MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_TABLET_FONT_SIZE,
  MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_SMART_FONT_SIZE,
  MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_PC_LINE_HEIGHT,
  MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_TABLET_LINE_HEIGHT,
  MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_SMART_LINE_HEIGHT,
  MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_TABLET_MAX_WIDTH,
  MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_TABLET_WIDTH,
  MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_TABLET_SMART_HEIGHT,
  MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_TABLET_SMART_FONT_SIZE,
  MIRA_HOME_LAYOUT_MODAL_BODY_INPUT_HEIGHT,
  MIRA_HOME_LAYOUT_MODAL_BODY_INPUT_PC_FONT_SIZE,
  MIRA_HOME_LAYOUT_MODAL_BODY_INPUT_FONT_WEIGHT,
  MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_PC_WIDTH,
  MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_PC_HEIGHT,
  MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_PC_FONT_SIZE,
  MAIN_BUTTON_BORDER_WIDTH,
  MIRA_PAYMENT_LAYOUT_PC_TABLET_EXPLAN_FONT,
  MIRA_PAYMENT_LAYOUT_PC_TABLET_EXPLAN_FONT_HEIGHT,
  MIRA_PAYMENT_LAYOUT_PC_TABLET_EXPLAN_FONT_SPACING,
  MIRA_PAYMENT_LAYOUT_SMART_TOTAL_FONT,
  MIRA_PAYMENT_LAYOUT_SMART_TOTAL_FONT_HEIGHT,
  MIRA_PAYMENT_LAYOUT_SMART_FONT_SPACING,
} from '../../styles/size';

import { TABLET_SIZE, SMART_SIZE } from '../../styles/common';

export const Layout = styled.div`
  display: inline-block;
  text-align: center;
  max-width: ${MIRA_PAYMENT_LAYOUT_PC_TABLET_WIDTH};
  width: ${MAIN_FULL_WIDTH};
  vertical-align: middle;
  margin-bottom: ${MIRA_PAYMENT_LAYOUT_PC_MARGIN_BOTTOM};
`;

export const Title = styled.p`
  margin-top: ${MIRA_PAYMENT_LAYOUT_PC_TITLE_MARGIN_TOP};
  margin-bottom: ${MIRA_PAYMENT_LAYOUT_PC_TITLE_MARGIN_BOTTOM};
  font-size: ${MIRA_PAYMENT_LAYOUT_PC_TITLE_FONT};
  font-weight: 700;
  line-height: ${MIRA_PAYMENT_LAYOUT_PC_TITLE_FONT_HEIGHT};
  letter-spacing: ${MIRA_PAYMENT_LAYOUT_PC_TITLE_FONT_SPACING};
  ${TABLET_SIZE} {
    margin-top: ${MIRA_PAYMENT_LAYOUT_TABLET_TITLE_MARGIN_TOP};
    margin-bottom: ${MIRA_PAYMENT_LAYOUT_TABLET_TITLE_MARGIN_BOTTOM};
    font-size: ${MIRA_PAYMENT_LAYOUT_TABLET_SMART_TITLE_FONT};
    line-height: ${MIRA_PAYMENT_LAYOUT_TABLET_SMART_TITLE_FONT_HEIGHT};
    letter-spacing: ${MIRA_PAYMENT_LAYOUT_TABLET_SMART_TITLE_FONT_SPACING};
  }
  ${SMART_SIZE} {
    margin-top: ${MIRA_PAYMENT_LAYOUT_SMART_TITLE_MARGIN_TOP};
    margin-bottom: ${MIRA_PAYMENT_LAYOUT_SMART_TITLE_MARGIN_BOTTOM};
    font-size: ${MIRA_PAYMENT_LAYOUT_TABLET_SMART_TITLE_FONT};
    line-height: ${MIRA_PAYMENT_LAYOUT_TABLET_SMART_TITLE_FONT_HEIGHT};
    letter-spacing: ${MIRA_PAYMENT_LAYOUT_TABLET_SMART_TITLE_FONT_SPACING};
  }
`;

export const ItemLabel = styled.div`
  font-size: ${MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_PC_FONT_SIZE};
  line-height: ${MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_PC_LINE_HEIGHT};
  text-align: left;
  font-weight: 500;
  width: auto;
  &.red-star::after {
    display: inline-block;
    content: '*';
    color: red;
    margin-left: 0;
    width: 0;
  }

  ${TABLET_SIZE} {
    font-size: ${MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_TABLET_FONT_SIZE};
    line-height: ${MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_TABLET_LINE_HEIGHT};
  }
  ${SMART_SIZE} {
    font-size: ${MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_SMART_FONT_SIZE};
    line-height: ${MIRA_REQUEST_INFORMATION_SELECTION_DESCRIBUTE_SMART_LINE_HEIGHT};
  }
`;

export const ReceiptInputGroup = styled(InputGroup)`
  width: 516px;
  // height: ${MIRA_HOME_LAYOUT_MODAL_BODY_INPUT_HEIGHT};
  height: 46px;
  font-size: 20px;
  border: 1px solid #c9caca;
  background: ${WHITE};
  & > input {
    // font-size: ${MIRA_HOME_LAYOUT_MODAL_BODY_INPUT_PC_FONT_SIZE};
    // font-size: 20px;
    color: ${BLACK};
    letter-spacing: 0.9px;
    // font-weight: ${MIRA_HOME_LAYOUT_MODAL_BODY_INPUT_FONT_WEIGHT};
    border-radius: 0px;
  }
  ${TABLET_SIZE} {
    font-size: 16px;
    width: 100%;
  }
  ${SMART_SIZE} {
    font-size: 16px;
    width: 350px;
    height: 45px;
  }
`;
export const ReceiptInput = styled(FormControl)`
  // font-size: ${MIRA_HOME_LAYOUT_MODAL_BODY_INPUT_PC_FONT_SIZE};
  font-size: 20px;
  color: ${BLACK};
  letter-spacing: 0.9px;
  // font-weight: ${MIRA_HOME_LAYOUT_MODAL_BODY_INPUT_FONT_WEIGHT};
  border-radius: 0px;

  ${TABLET_SIZE} {
    font-size: 16px;
    width: 100%;
  }
  ${SMART_SIZE} {
    font-size: 16px;
    width: 350px;
    height: 45px;
  }
`;
export const SuffixText = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #666;
  // font-size: ${MIRA_HOME_LAYOUT_MODAL_BODY_INPUT_PC_FONT_SIZE};
  font-size: 20px;

  ${TABLET_SIZE} {
    font-size: 16px;
  }
  ${SMART_SIZE} {
    font-size: 16px;
  }
`;

export const ReceiptButton = styled.button`
  width: ${MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_PC_WIDTH};
  height: ${MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_PC_HEIGHT};
  border: 3px solid ${RED};
  box-shadow: 0px 5px 8px ${LARGE_BUTTON_BOX_SHADOW_COLOR};
  font-size: ${MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_PC_FONT_SIZE};
  font-weight: 700;
  line-height: 29px;
  background: ${WHITE};
  border-radius: 50px;
  color: ${RED};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 34px;

  &:disabled {
    opacity: 0.6 !important;
    background: ${WHITE} !important;
    color: ${RED} !important;
  }

  &:hover {
    background: ${RED};
    color: ${WHITE};
    border: ${MAIN_BUTTON_BORDER_WIDTH} solid ${RED};
  }
  ${TABLET_SIZE} {
    max-width: ${MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_TABLET_MAX_WIDTH};
    width: ${MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_TABLET_WIDTH};
    height: ${MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_TABLET_SMART_HEIGHT};
    font-size: ${MIRA_HOME_LAYOUT_MODAL_BODY_LARGE_BUTTON_TABLET_SMART_FONT_SIZE};
  }

  ${SMART_SIZE} {
    width: ${MAIN_FULL_WIDTH};
  }
`;
export const ReceiptButtonSpinner = styled(Spinner)`
  margin-right: 8px;
`;

export const ReceiptErrorMessage = styled.p`
  text-align: left;
  color: ${RED};
  letter-spacing: -0.1px;
`;
export const ReceiptErrorMessageText = styled.span`
  display: block;
  margin-bottom: -10px;
  font-size: 22px;

  ${TABLET_SIZE} {
    font-size: 18px;
  }
  ${SMART_SIZE} {
    font-size: 16px;
  }
`;

export const Explanation = styled.p`
  font-size: ${MIRA_PAYMENT_LAYOUT_PC_TABLET_EXPLAN_FONT};
  line-height: ${MIRA_PAYMENT_LAYOUT_PC_TABLET_EXPLAN_FONT_HEIGHT};
  letter-spacing: ${MIRA_PAYMENT_LAYOUT_PC_TABLET_EXPLAN_FONT_SPACING};
  text-align: left;
  font-weight: 500;
  ${TABLET_SIZE} {
    font-size: ${MIRA_PAYMENT_LAYOUT_PC_TABLET_EXPLAN_FONT};
    line-height: ${MIRA_PAYMENT_LAYOUT_PC_TABLET_EXPLAN_FONT_HEIGHT};
    letter-spacing: ${MIRA_PAYMENT_LAYOUT_PC_TABLET_EXPLAN_FONT_SPACING};
  }
  ${SMART_SIZE} {
    font-size: ${MIRA_PAYMENT_LAYOUT_SMART_TOTAL_FONT};
    line-height: ${MIRA_PAYMENT_LAYOUT_SMART_TOTAL_FONT_HEIGHT};
    letter-spacing: ${MIRA_PAYMENT_LAYOUT_SMART_FONT_SPACING};
  }
`;
